<template>
    <div class="box">
      <div class="text text-gray">協作夥伴</div>
      <img class="img img-1" src="/assets/image/cooperate_1.png" />
<!--      <div :class="display">-->
<!--        <img  class="img img-1" src="/assets/image/cooperate_1.png" />-->
<!--      </div>-->

<!--      <div :class="display">-->
<!--        <img  class="img img-2" src="/assets/image/cooperate_2.png" />-->
<!--        <img  class="img img-3" src="/assets/image/cooperate_3.png" />-->
<!--        <img  class="img img-4" src="/assets/image/cooperate_4.png" />-->
<!--      </div>-->

    </div>

</template>

<script>

export default {
  name: "LaunchCooperate",
  props: {
    display: {type: String, default: 'inline'}
  }
}
</script>

<style scoped>
.box{
  text-align: center;
  margin-top: 1vh;
}
.img{
  /*width: 20%;*/
  margin: 1vh 1%;
}

.text{
  text-align: center;
  font-size: var(--ecs-font-sm);
  font-family: SimHei;
}

.img-1{
    height: 40%;
  /*width: 38%;*/
}
.img-2{
  width: 10%;
}
.img-3{
  width: 20%;
}
.img-4{
  width: 10%;
}
.inline{
  display: inline;
}
.inherit{
  display: inherit;
}

</style>
